import { NavigationStackScreenComponent } from 'react-navigation-stack'
import React from 'react'
import { images } from '../../constants/searchAssets'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { ATLImageLogo, ImageResizeModeEnum } from '@appsimples/atlantica-react-native'
import styled from 'styled-components/native'
import { Colors } from '../../constants/colors'

const LogoContainer = styled.View`
  background-color: ${Colors.white};
  height: 100%;
  justify-content: center;
`

export const TransitionScreen: NavigationStackScreenComponent = () => {
  const transitionTime = 1000
  setTimeout(() => Coordinator.goToMainScreen(), transitionTime)

  return (
    <LogoContainer>
      <ATLImageLogo source={images.mainLogo} imageBaseProps={{ resizeMode: ImageResizeModeEnum.contain }} />
    </LogoContainer>
  )
}
TransitionScreen.navigationOptions = {
  headerShown: false,
}
